import { getField } from 'vuex-map-fields';

// TYPES

export const SET_FILTERS_DATA_KEY = 'SET_FILTERS_DATA_KEY';
export const SET_FILTER_AMOUNT = "SET_FILTER_AMOUNT";
export const SET_FILTER_STATE = "SET_FILTER_STATE";
export const SET_FILTER_CONCEPT = "SET_FILTER_CONCEPT";
export const SET_FILTER_CONTRAPARTIDA = "SET_FILTER_CONTRAPARTIDA";
export const SET_FILTER_NOT_CONTRAPARTIDA = "SET_FILTER_NOT_CONTRAPARTIDA";
export const SET_FILTER_ASIENTO = "SET_FILTER_ASIENTO";
export const SET_FILTER_DATE_FROM = "SET_FILTER_DATE_FROM";
export const SET_FILTER_DATE_TO = "SET_FILTER_DATE_TO";
export const SET_FILTER_PUNTEADO = "SET_FILTER_PUNTEADO";
export const SET_FILTER_AMOUNT_FROM = "SET_FILTER_AMOUNT_FROM" 
export const SET_FILTER_AMOUNT_TO = "SET_FILTER_AMOUNT_TO" 
export const SET_FILTER_ACCOUNTING_FROM = "SET_FILTER_ACCOUNTING_FROM"
export const SET_FILTER_ACCOUNTING_TO = "SET_FILTER_ACCOUNTING_TO"
export const SET_FILTER_SHOW_POSSIBLE_DUPLICATES = "SET_FILTER_SHOW_POSSIBLE_DUPLICATES";
export const CLEAN_FILTER = "CLEAN_FILTER";
export const RESET_FILTERS = "RESET_FILTERS";


// STATE
const state = () => ({
    listFilters: {
        state: {
            'name': 'state',
            'label': 'Estado',
            'values':[], // TODO: multiple?
            'user_values': [
                { value: '', text: 'Todos'},
                { value: 'draft', text: 'Borrador'},
                { value: 'pending', text: 'Contabilizando'},
                { value: 'accounting', text: 'Contabilizando...'},
                { value: 'done', text: 'Contabilizado'},
                { value: 'not_done', text: 'No Contabilizado'},
                { value: 'done_imported', text: 'Contabilizado y importado'},
                { value: 'not_done_imported', text: 'No Contabilizado ni importado'},
                { value: 'pending_sync', text: 'Pte. de sincronización'},
                { value: 'imported', text: 'Importado'},
                { value: 'error', text: 'Error'},
                { value: 'downloaded', text: 'Descargado'},
                { value: 'reconciled', text: 'Conciliada con ERP'},
                { value: 'prevision', text: 'Previsión'},
            ],
            'multiple': false,
            'value': '',
            'type': 'select',
            'icon': 'mdi-file-chart',
            'text':''
        },
        concept: {
            'name': 'concept',
            'label': 'Concepto',
            'value': '',
            'type': 'text',
            'icon': 'mdi-file-document',
        },
        contrapartida: {
            'name': 'contrapartida',
            'label': 'Contrapartida',
            'value': '',
            'type': 'text',
            'icon': 'mdi-file-document',
        },
        not_contrapartida: {
            'name': 'not_contrapartida',
            'label': 'Contrapartida distinta',
            'value': '',
            'type': 'text',
            'icon': 'mdi-file-document-remove',
        },
        date_from: {
            'name': 'date_from',
            'label': 'Fecha desde',
            'value': '',
            'type': 'date',
            'icon': 'mdi-calendar',
        },
        date_to: {
            'name': 'date_to',
            'label': 'Fecha hasta',
            'value': '',
            'type': 'date',
            'icon': 'mdi-calendar',
        },
        punteado: {
            'name': 'punteado',
            'label': 'Revisado',
            'values': [], // TODO: multiple?
            'user_values': [
                { value: '', text: 'Todos'},
                { value: 'yes', text: 'Sí'},
                { value: 'no', text: 'No'},
            ],
            'multiple': false,
            'value': '',
            'type': 'select',
            'icon': 'mdi-check-circle',
            'text':''
        },
        amount:{
            'name': 'amount',
            'label': 'Importe exacto',
            'value': '',
            'type': 'number',
            'icon': 'mdi-cash',
        },
        amount_from: {
            'name': 'amount_from',
            'label': 'Importe desde', 
            'value': '',
            'type': 'number',
            'icon': 'mdi-cash',
        }, 
        amount_to: {
            'name': 'amount_to',
            'label': 'Importe hasta', 
            'value': '',
            'type': 'number',
            'icon': 'mdi-cash',
        },
        asiento: {
            'name': 'asiento',
            'label': 'Asiento exacto',
            'value': '',
            'type': 'text',
            'icon': 'mdi-file-document',
        },
        accounting_from: {
            'name': 'accounting_from',
            'label': 'Asiento desde',
            'value': '',
            'type': 'text',
            'icon': 'mdi-file-document',
        },
        accounting_to: {
            'name': 'accounting_to',
            'label': 'Asiento hasta',
            'value': '',
            'type': 'text',
            'icon': 'mdi-file-document',
        },
        possible_duplicates: {
            'name': 'possible_duplicates',
            'label': 'Posibles duplicados',
            'values': [], // TODO: multiple?
            'user_values': [
                { value: 'yes', text: 'Sí'},
            ],
            'multiple': false,
            'value': '',
            'type': 'select',
            'icon': 'mdi-check-circle',
            'text':''
        }
    }
});

// GETTERS
const getters = {
    listFilters: state => state.listFilters,
    getField
}

// ACTIONS

const removeAllFilters = ({commit}, { skipStateFilter = false } = {}) => {
    let text=''
    let value=''
    commit(SET_FILTER_CONCEPT, value);
    commit(SET_FILTER_CONTRAPARTIDA, value);
    commit(SET_FILTER_NOT_CONTRAPARTIDA, value);
    if(!skipStateFilter) {
        commit(SET_FILTER_STATE, {value,text});
    }
    commit(SET_FILTER_DATE_FROM, value);
    commit(SET_FILTER_DATE_TO, value);
    commit(SET_FILTER_PUNTEADO, {value,text});
    commit(SET_FILTER_AMOUNT, {value,text});
    commit(SET_FILTER_AMOUNT_FROM, {value, text}); 
    commit(SET_FILTER_AMOUNT_TO, {value, text}); 
    commit(SET_FILTER_ASIENTO, value);
    commit(SET_FILTER_ACCOUNTING_FROM, {value, text});
    commit(SET_FILTER_ACCOUNTING_TO, {value, text});
    commit(SET_FILTER_SHOW_POSSIBLE_DUPLICATES, {value, text});
}

const updateObject = ({commit}, {key,value,text}) => {
    if(key=='contrapartida')
        commit(SET_FILTER_CONTRAPARTIDA, value);
    if(key=='not_contrapartida')
        commit(SET_FILTER_NOT_CONTRAPARTIDA, value);
    if(key=='concept')
        commit(SET_FILTER_CONCEPT, value);
    if(key=='state')
        commit(SET_FILTER_STATE, {value,text});
    if(key=='date_from')
        commit(SET_FILTER_DATE_FROM, value);
    if(key=='date_to')
        commit(SET_FILTER_DATE_TO, value);
    if(key=='punteado')
        commit(SET_FILTER_PUNTEADO, {value,text});
    if(key=='amount')
        commit(SET_FILTER_AMOUNT, {value,text});
    if(key=='amount_from')
        commit(SET_FILTER_AMOUNT_FROM, {value,text}); 
    if(key=='amount_to')
        commit(SET_FILTER_AMOUNT_TO, {value,text}); 
    if(key=='asiento')
        commit(SET_FILTER_ASIENTO, value);
    if(key=='accounting_from')
        commit(SET_FILTER_ACCOUNTING_FROM, {value,text}); 
    if(key=='accounting_to')
        commit(SET_FILTER_ACCOUNTING_TO, {value,text}); 
    if(key=='possible_duplicates')
        commit(SET_FILTER_SHOW_POSSIBLE_DUPLICATES, {value,text});
    
};

const setFilterAmount = ({commit}, value) => {
    commit(SET_FILTER_AMOUNT, value);
};

const setFilterState = ({commit}, value) => {
    commit(SET_FILTER_STATE, value);
};

const setFilterConcept = ({commit}, value) => {
    commit(SET_FILTER_CONCEPT, value);
};

const setFilterAsiento = ({commit}, value) => {
    commit(SET_FILTER_ASIENTO, value);
};

const setFilterDateFrom = ({commit}, value) => {
    commit(SET_FILTER_DATE_FROM, value);
};
const setFilterDateTo = ({commit}, value) => {
    commit(SET_FILTER_DATE_TO, value);
};

const setFilterAmountFrom = ({commit}, value) => { 
    commit(SET_FILTER_AMOUNT_FROM)
}
const setFilterAmountTo = ({commit}, value) => { 
    commit(SET_FILTER_AMOUNT_TO)
}

const setFilterAccountingFrom = ({commit}, value) => { 
    commit(SET_FILTER_ACCOUNTING_FROM)
}
const setFilterAccountingTo = ({commit}, value) => { 
    commit(SET_FILTER_ACCOUNTING_TO)
}

const setFilter = ({commit}, {key, value}) => {
    commit(SET_FILTERS_DATA_KEY, {key, value});
};

const cleanFilter = ({commit}, key) => {
    commit(CLEAN_FILTER, key);
};

const resetFilters = ({commit}) => {
    commit(RESET_FILTERS);
};

export const actions = {
    setFilterAmount,
    setFilterState,
    setFilterConcept,
    setFilterAsiento,
    setFilterDateFrom,
    setFilterDateTo,
    setFilterAmountFrom,
    setFilterAmountTo, 
    setFilterAccountingFrom,
    setFilterAccountingTo,
    setFilter,
    cleanFilter,
    resetFilters,
    updateObject,
    removeAllFilters,
}

// MUTATIONS
const mutations = {
    [SET_FILTERS_DATA_KEY](state, {key, value}) {
        state.listFilters[key].value = value;
    },
    [SET_FILTER_AMOUNT](state, {value}) {
        state.listFilters['amount'].value = value;
    },
    [SET_FILTER_STATE](state, {value,text}) {
        state.listFilters['state'].value = value;
        state.listFilters['state'].text = text;
    },
    [SET_FILTER_CONCEPT](state, value) {
        state.listFilters['concept'].value = value;
    },
    [SET_FILTER_CONTRAPARTIDA](state, value) {
        state.listFilters['contrapartida'].value = value;
    },
    [SET_FILTER_NOT_CONTRAPARTIDA](state, value) {
        state.listFilters['not_contrapartida'].value = value;
    },
    [SET_FILTER_ASIENTO](state, value) {
        state.listFilters['asiento'].value = value;
    },
    [SET_FILTER_DATE_FROM](state, value) {
        state.listFilters['date_from'].value = value;
    },
    [SET_FILTER_DATE_TO](state, value) {
        state.listFilters['date_to'].value = value;
    },
    [SET_FILTER_PUNTEADO](state, {value,text}) {
        state.listFilters['punteado'].value = value;
        state.listFilters['punteado'].text = text;
    },
    [SET_FILTER_AMOUNT_FROM](state, {value,text}){ 
        state.listFilters['amount_from'].value = value;
    },
    [SET_FILTER_AMOUNT_TO](state, {value,text}){ 
        state.listFilters['amount_to'].value = value;
    },
    [SET_FILTER_ACCOUNTING_FROM](state, {value,text}){ 
        state.listFilters['accounting_from'].value = value;
    },
    [SET_FILTER_ACCOUNTING_TO](state, {value,text}){ 
        state.listFilters['accounting_to'].value = value;
    },
    [SET_FILTER_SHOW_POSSIBLE_DUPLICATES](state, {value, text}) {
        state.listFilters['possible_duplicates'].value = value;
        state.listFilters['possible_duplicates'].text = text;
    },
    [CLEAN_FILTER](state, key) {
        state.listFilters[key].value = '';
    },
    [RESET_FILTERS](state) {
        for (const key in state.listFilters) {
            state.listFilters[key].value = '';
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}